module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-25.40634488.png";